module.exports = __webpack_public_path__ + "static/img/验证码.247e0c76.svg";